export const HOMEPAGE = "/";
export const ABOUT = "/about";
export const ABOUTDSA = "/dropshipping";
export const DOWNLOAD = "/download";
export const PUBLIC_CONNECT = "/public/connect";
export const PUBLIC_HOME = "/public/";
